/*
 * Misc functions
 */

/**
 * @param {string} str
 * @returns {boolean} true if the given string contains non-BMP chars otherwise false
 */
export function containsNonBmpChars(str) {
    // check for first (high) surrogate in a non-BMP character
    return /[\uD800-\uDBFF]/.test(str);
}

const util = { containsNonBmpChars };

export default util;
